import { FC } from 'react';

import { CampaignSteps } from 'utils/constants/campaign';

import { GridColumn, GridLayout, GridRow } from '@hh.ru/magritte-ui';

import { StickyActionBarWrapper } from 'components/common/StickyActionBarWrapper/StickyActionBarWrapper';
import { CpcActions } from 'components/CpcFlexibleCreate/CpcActions/CpcActions';
import { CpcForm } from 'components/CpcFlexibleCreate/CpcForm/CpcForm';
import { useCpcFlexibleCreateData } from 'components/CpcFlexibleCreate/useCpcFlexibleCreateData';

import { useSelector } from 'store/utils';

export const CpcFlexibleCreate: FC = () => {
    const { currentStep } = useSelector((state) => state.createCampaign);
    const step = String(currentStep) as CampaignSteps;

    const { renderSidebarElements } = useCpcFlexibleCreateData();

    return (
        <StickyActionBarWrapper
            content={
                <GridLayout>
                    <GridRow>
                        <GridColumn xs={4} s={8} m={7} l={6}>
                            <CpcForm />
                        </GridColumn>
                        <GridColumn xs={0} l={2} />
                        <GridColumn xs={4} s={8} m={5} l={4}>
                            {renderSidebarElements({ currentStep: step })}
                        </GridColumn>
                    </GridRow>
                </GridLayout>
            }
            actionBar={<CpcActions />}
        />
    );
};
